var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"pa-0 ma-0",attrs:{"fluid":""}},[_c('dd-pp-function-list'),_c('dd-pp-notification')],1)}
var staticRenderFns = []

export { render, staticRenderFns }